"use strict";
exports.__esModule = true;
require('./badge.css');
exports.default = {
  "badge": "pf-v5-c-badge",
  "modifiers": {
    "read": "pf-m-read",
    "unread": "pf-m-unread"
  },
  "themeDark": "pf-v5-theme-dark"
};